import { Navigate, Outlet } from "react-router-dom";
import { usePlatformPermissions } from "../../shared/hooks/usePlatformPermissions";

export default function PlatformAccessRoute({ permissions = [], globalOnly = false }) {
  const { isSuperAdmin, isPermissionGranted, hasGlobalAccess, platformAccessLoading } = usePlatformPermissions();
  if (platformAccessLoading) {
    return <div className="p-6 text-center text-sm text-slate-500">Checking platform access…</div>;
  }
  const hasRequiredAccess = permissions.some((permission) =>
    globalOnly ? hasGlobalAccess(permission) : isPermissionGranted(permission)
  );
  if (!isSuperAdmin && !hasRequiredAccess) {
    return <Navigate to="/unauthorized" replace />;
  }
  return <Outlet />;
}
